const config = require('./config.yaml');

const downloadCenter = (function () {
	let $dc = $('.js-download-center'), //глобальная обертка download-center
		$rows = $dc.find('.js-row'), //линии
		$triggers = $dc.find('.js-checkbox-item'), //все чекбоксы
		$downloadButton = $('.js-download-selected');

	return {
		init: init,
		getActiveLinks: getActiveLinks,
	};

	function init() {
		initCheckTriggers();
		initDownloadButton();
		checkDownloadButtonAccess();
	}

	function checkDownloadButtonAccess() {
		let links = getActiveLinks();

		if (links.length && $downloadButton.length) {
			$downloadButton.prop('disabled', false);
			$downloadButton.removeClass('is-disabled');
		} else {
			$downloadButton.prop('disabled', true);
			$downloadButton.addClass('is-disabled');
		}
	}

	function initCheckTriggers() {
		if ($dc.length && $rows.length && $triggers.length) {
			$.each($triggers, function () {
				let $trigger = $(this);

				$trigger.on('change', function () {
					let sectionParentAttr = $(this).attr('data-is-all-section'), //чексбокс-родитель
						sectionItemAttr = $(this).attr('data-in-section'); //чекбокс-потомок-секции

					//если мы кликнули на родителя
					if (typeof sectionParentAttr !== typeof undefined && sectionParentAttr !== false) {
						let $accordionTrigger = $(this)
							.closest('.js-row')
							.find('.accordion__button');

						//прочекиваем всех потомков, либо снимаем чек
						if ($(this).prop('checked')) {
							$triggers.filter((i, item) => {
								return $(item).attr('data-in-section') == sectionParentAttr;
							}).prop('checked', true);

							if ($accordionTrigger.length) {
								let hashCode = $accordionTrigger.attr('href').replace('#', '');
								window.location.hash = hashCode;
							}
						} else {
							$triggers.filter((i, item) => {
								return $(item).attr('data-in-section') == sectionParentAttr;
							}).prop('checked', false);
						}
						//иначе если мы кликнули на потомка
					} else if (typeof sectionItemAttr !== typeof undefined && sectionItemAttr !== false) {
						//считаем общее количество всех потомков
						let totalCount = $triggers.filter((i, item) => {
							return $(item).attr('data-in-section') == sectionItemAttr;
						}).length;

						if ($(this).prop('checked')) {
							//считаем общее количество чекнутых потомков
							let checkedCount = $triggers.filter((i, item) => {
								return (($(item).attr('data-in-section') == sectionItemAttr) && $(item).prop('checked'));
							}).length;

							//если чекнуты все, то чекаем родителя
							// if (totalCount === checkedCount) {
							// 	$triggers.filter((i, item) => {
							// 		return (($(item).attr('data-is-all-section') == sectionItemAttr));
							// 	}).prop('checked', true);
							// }

							//если чекнут хотя бы один, то чекаем родителя
							if (checkedCount > 0) {
								$triggers.filter((i, item) => {
									return (($(item).attr('data-is-all-section') == sectionItemAttr));
								}).prop('checked', true);
							}
						} else {
							let uncheckedCount = $triggers.filter((i, item) => {
								return (($(item).attr('data-in-section') == sectionItemAttr) && !$(item).prop('checked'));
							}).length;

							//если хотя бы один не чекнут - снимаем чек с родителя
							// if (totalCount !== uncheckedCount) {
							// 	$triggers.filter((i, item) => {
							// 		return (($(item).attr('data-is-all-section') == sectionItemAttr));
							// 	}).prop('checked', false);
							// }

							//если все не чекнуты - снимаем чек с родителя
							if (totalCount === uncheckedCount) {
								$triggers.filter((i, item) => {
									return (($(item).attr('data-is-all-section') == sectionItemAttr));
								}).prop('checked', false);
							}
						}
					}
					checkDownloadButtonAccess();
				});
			});
		}
	}

	function initDownloadButton() {
		if ($downloadButton.length) {
			$downloadButton.click(function () {
				let query = downloadCenter.getActiveLinks()
					.map(file => `files[]=${encodeURIComponent(file)}`)
					.join('&');

				query += `&filename=files&site=${templateVars.site}&lang=${templateVars.lang}`;
				window.open(`/download?${query}`, '_blank');
				return false;
			});
		}
	}

	function getActiveLinks() {
		let $checkedTriggers = $triggers.filter((i, item) => {
				let $item = $(item);
				//берем чекнутые чекбоксы, но исключаем те, которые в заголовке секций
				return (!$item.attr('data-is-all-section') && $item.prop('checked'));
			}),
			links = [];
		$.each($checkedTriggers, function () {
			let link = $(this)
				.closest('.js-row')
				.find('.js-link')
				.attr('data-link');

			if (link) {
				links.push(link);
			}
		});
		return links;
	}
}());

downloadCenter.init();



// WEBPACK FOOTER //
// ./temp/components/download-center/index.js